//-------------------------------------------------------------------------------------------------- Imports
import { Progress } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import _ from "lodash";
import moment from "moment";

//-------------------------------------------------------------------------------------------------- Interfaces
interface CircleOfDataUsageProps {
    total: string;
    available: string;
    title: string;
    vigency: string;
};

//-------------------------------------------------------------------------------------------------- Functions
const parseData = (value: string): number => {
    value = value.toUpperCase();
    // Se comprara con la B porque todos comparten ese dato (K'B', M'B', G'B')
    // Y se resta una posición para abarcar el data completo
    return (
        (value.includes("GB")) ? (
            parseFloat(value.substring(0, value.indexOf("B") - 1)) * 1000
        ) : ((value.includes("KB")) ? (
            parseFloat(value.substring(0, value.indexOf("B") - 1)) / 1000
        ) : (
            parseFloat(value.substring(0, value.indexOf("B") - 1))
        ))
    );
}

//-------------------------------------------------------------------------------------------------- Component
const CircleOfDataUsage = (props: CircleOfDataUsageProps) => {
    const { total, available, title, vigency } = props;
    const percentage: number = (parseData(available) * 100) / parseData(total);
    const availableData = _.split(available, " ");
    const colors = {
        '0%': '#0a60c6',
        '25%': '#3792db',
        "50%": "#6fd1f5",
        '75%': '#3792db',
        '100%': '#0a60c6',
    };

    return (
        <div style={styles.mainContainer}>
            <div style={styles.firstCircle}>
                <Progress
                    type="circle"
                    percent={percentage}
                    strokeColor={colors}
                    format={() => (
                        <div style={styles.secondCircle}>
                            <div style={styles.thirdCircle}>
                                <div>
                                    <p style={styles.availableText}>
                                        <b>
                                            {`${availableData[0]} `}
                                            <span style={styles.generalText}>{availableData[1]}</span>
                                        </b>
                                    </p>
                                </div>
                                <div>
                                    <p style={styles.generalText}>
                                        de {total}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    trailColor="transparent"
                    size={150}
                />
            </div>
            <div style={styles.infoContainer}>
                <h3 style={{ color: "#5f5f5f" }}>
                    {title}
                </h3>
                <h3 style={{ margin: 0 }}>
                    {(vigency && vigency.length > 0) ? (
                        `Vence ${moment(vigency).format("DD/MM/YYYY")}`
                    ) : (
                        "Sin Vigencia Aplicable"
                    )}
                </h3>
            </div>
        </div>
    );
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    firstCircle: {
        display: "flex",
        width: 190,
        height: 190,
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        marginBottom: 15,
        borderRadius: "50%",
        backgroundColor: "#e5e5e5",
    },
    secondCircle: {
        display: "flex",
        width: 150,
        height: 150,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "transparent",
    },
    thirdCircle: {
        display: "flex",
        flexDirection: "column",
        width: "75%",
        height: "75%",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        backgroundColor: "#fafafa",
        color: "#000000",
    },
    availableText: {
        margin: 0,
        marginBottom: 5,
        fontSize: 18,
    },
    generalText: {
        margin: 0,
        fontSize: 13,
    },
    infoContainer: {
        display: "flex",
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginLeft: 10
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default CircleOfDataUsage;
